import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import defaultImg from "./../../../images/task/img1.jpg";
import { var_api, image_api } from "../../../constant";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const CuttingMaster = () => {
  const tableHeaders = [
    "#",
    "Image",
    "Product Name",
    "Cutting Code",
    "Cutting ",
    "Description",
    "Type",
    "Status",
    "Action",
  ];

  const [cuttingData, setCuttingData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductFilter, setSelectedProductFilter] = useState(null);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    warehouse_id: 1,
    cutting_code: "",
    cutting_name: "",
    cutting_description: "",
    cutting_image: "",
    type: "",
    active_status: 1,
    product_id: "",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInitialData();
  }, []);

  // Load products and set first product as default
  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchProducts();
      // After products are loaded, fetch cutting data with first product
      await fetchCuttingData();
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchProducts = async () => {
    try {
      const warehouse_id = localStorage.getItem("warehouse_id");
      const res = await axios.get(
        `${var_api}sa_veemart_product_master/getactivebywarehouse/${warehouse_id}`
      );

      const products = res.data.map((item) => ({
        value: item.id,
        label: item.product_name,
      }));

      setProductList(products);

      // Set the first product as default filter if products exist
      if (products.length > 0) {
        setSelectedProductFilter(products[0]);
      }
    } catch (err) {
      console.error("Failed to load products", err);
    }
  };

  const fetchCuttingData = async (productId = null) => {
    try {
      const warehouse_id = localStorage.getItem("warehouse_id");
      
      // Use provided productId, or selected filter, or first product from list
      const filterProductId = productId || 
                              (selectedProductFilter ? selectedProductFilter.value : productList[0]?.id) || 
                              (productList.length > 0 ? productList[0]?.id : null);

      // Build URL with warehouse_id and product_id
      let url = `${var_api}veemart_meat_cutting_instructions/getcuttingbywarehouseid/${warehouse_id}/${filterProductId}`;
      
     
      const res = await axios.get(url);
      setCuttingData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch cutting data", err);
      toast.error("Failed to fetch cutting data");
    }
  };

  // Handle product filter change
  const handleProductFilterChange = (option) => {
    setSelectedProductFilter(option);
    setCurrentPage(1); // Reset to first page
    fetchCuttingData(option ? option.value : null);
  };

  // Refresh data handler
  const handleRefresh = () => {
    fetchCuttingData();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      warehouse_id: 1,
      cutting_code: "",
      cutting_name: "",
      cutting_description: "",
      cutting_image: "",
      type: 0,
      active_status: 1,
      product_id: ""
    });
    setFile(null);
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setFile(null);
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newErrors = {};
    if (!String(formData.cutting_code || "").trim())
      newErrors.cutting_code = "Cutting code is required";
    if (!String(formData.cutting_name || "").trim())
      newErrors.cutting_name = "Cutting name is required";
    if (!formData.product_id)
      newErrors.product_id = "Product selection is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      const form = new FormData();
      form.append("warehouse_id", 1);
      form.append("cutting_code", formData.cutting_code);
      form.append("cutting_name", formData.cutting_name);
      form.append("cutting_description", formData.cutting_description);
      form.append("type", formData.type);
      form.append("active_status", formData.active_status);
      form.append("product_id", formData.product_id);

      if (file) form.append("cutting_image", file);

      const headers = { headers: { "Content-Type": "multipart/form-data" } };
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(
          `${var_api}veemart_meat_cutting_instructions/update/${formData.id}`,
          form,
          headers
        );
      } else {
        res = await axios.post(`${var_api}veemart_meat_cutting_instructions/post`, form, headers);
      }

      toast.success(res?.data?.message || "Cutting saved successfully!");
      setShowModal(false);
      fetchCuttingData(); // Refresh with current filter
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save cutting");
    } finally {
      setLoading(false);
    }
  };

  // Filter data based on search query
  const filteredData = cuttingData && cuttingData?.filter((item) => {
    const matchesSearch = searchQuery === "" || 
      Object.entries(item).some(([key, val]) =>
        typeof val === "string" &&
        val.toLowerCase().includes(searchQuery.toLowerCase())
      );
    return matchesSearch;
  });

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex gap-2 align-items-center">
                  <div style={{ minWidth: "200px" }}>
                    <Select
                      options={productList}
                      value={selectedProductFilter}
                      onChange={handleProductFilterChange}
                      placeholder="Select Product"
                      isSearchable
                      isClearable
                      className="basic-single"
                      classNamePrefix="select"
                    />
                  </div>
                  <Button 
                    variant="outline-secondary" 
                    onClick={handleRefresh}
                    title="Refresh"
                  >
                    <i className="fas fa-sync-alt"></i>
                  </Button>
                </div>
                
                <div className="d-flex gap-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                    style={{ width: "250px" }}
                  />
                  <Button variant="secondary" onClick={handleAddClick}>
                    Add
                  </Button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {tableHeaders.map((header, idx) => (
                        <th key={idx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center text-muted py-3">
                          {selectedProductFilter 
                            ? `No cutting instructions found for "${selectedProductFilter.label}"` 
                            : "No cutting instructions found"}
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={
                                item.cutting_image
                                  ? `${image_api}${item.cutting_image.replace(
                                      /^test\//,
                                      ""
                                    )}`
                                  : defaultImg
                              }
                              alt="cutting"
                              width="40"
                              height="40"
                              className="rounded"
                              onClick={() =>
                                window.open(
                                  `${image_api}${item.cutting_image.replace(
                                    /^test\//,
                                    ""
                                  )}`,
                                  "_blank"
                                )
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </td>
                          <td>{item.product_name}</td>
                          <td>{item.cutting_code}</td>
                          <td>{item.cutting_name}</td>
                          <td>{item.cutting_description}</td>
                          <td>{item.type}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.active_status === 1 ||
                                item.active_status === "Active"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {item.active_status === 1 ||
                              item.active_status === "Active"
                                ? "Active"
                                : "Inactive"}
                            </span>
                          </td>
                          <td className="text-center">
                            <Link
                              to="#"
                              className="btn shadow btn-xs sharp me-1"
                              style={{
                                backgroundColor: "#007bff",
                                color: "white",
                              }}
                              onClick={() => handleEditClick(item)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="text-muted">
                    Showing {paginatedData.length} of {filteredData.length} entries
                    {selectedProductFilter && ` for "${selectedProductFilter.label}"`}
                  </div>
                  <div>
                    {[...Array(totalPages)].map((_, idx) => (
                      <Button
                        key={idx}
                        variant={currentPage === idx + 1 ? "primary" : "light"}
                        onClick={() => setCurrentPage(idx + 1)}
                        className="me-1"
                      >
                        {idx + 1}
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal Form */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isEditMode ? "Edit Cutting" : "Add Cutting"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Select Product <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={productList}
                      value={productList.find((p) => p.value === formData.product_id) || null}
                      onChange={(option) => {
                        setFormData({ ...formData, product_id: option?.value || "" });
                      }}
                      placeholder="Search product..."
                      isSearchable
                    />
                    {errors.product_id && (
                      <div className="text-danger small mt-1">{errors.product_id}</div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Cutting Code <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="cutting_code"
                      value={formData.cutting_code}
                      placeholder="Enter cutting code"
                      onChange={handleInputChange}
                    />
                    {errors.cutting_code && (
                      <div className="text-danger small mt-1">
                        {errors.cutting_code}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Cutting Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="cutting_name"
                      value={formData.cutting_name}
                      placeholder="Enter cutting name"
                      onChange={handleInputChange}
                    />
                    {errors.cutting_name && (
                      <div className="text-danger small mt-1">
                        {errors.cutting_name}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                {isEditMode && (
                  <Col md={6}>
                    <Form.Group className="mb-2 d-flex align-items-center gap-2">
                      <Form.Label className="mb-0">
                        {formData.active_status === 1 ||
                        formData.active_status === "Active"
                          ? "Active"
                          : "Inactive"}
                      </Form.Label>
                      <Form.Check
                        type="switch"
                        id="active-status-switch"
                        checked={
                          formData.active_status === 1 ||
                          formData.active_status === "Active"
                        }
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            active_status: e.target.checked ? 1 : 0,
                          })
                        }
                        className={
                          formData.active_status === 1 ||
                          formData.active_status === "Active"
                            ? "custom-switch-green"
                            : ""
                        }
                      />
                    </Form.Group>
                  </Col>
                )}

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      name="cutting_description"
                      value={formData.cutting_description}
                      placeholder="Enter description"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Image</Form.Label>
                    {isEditMode && formData.cutting_image && !file && (
                      <div className="mb-2 d-flex gap-2 align-items-center">
                        <img
                          src={`${image_api}${formData.cutting_image.replace(
                            /^test\//,
                            ""
                          )}`}
                          alt="Preview"
                          width="80"
                          className="rounded border"
                        />
                      </div>
                    )}
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      disabled={loading}
                      onClick={() =>
                        setFormData({
                          id: null,
                          warehouse_id: 1,
                          cutting_code: "",
                          cutting_name: "",
                          cutting_description: "",
                          cutting_image: "",
                          type: "",
                          active_status: 1,
                          product_id: ""
                        })
                      }
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => setShowModal(false)}
                      disabled={loading}
                    >
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        <style>{`
          .custom-switch-green .form-check-input:checked {
            background-color: #28a745 !important;
            border-color: #28a745 !important;
          }
        `}</style>
      </Card>

      <ToastContainer />
    </>
  );
};

export default CuttingMaster;